// extracted by mini-css-extract-plugin
export default {"checkbox":"hmZVnqv7ZWvvOw_2LVDP","check":"WWHYKoOg_vIylJCoCYN7"};